/* eslint-disable @typescript-eslint/no-unused-vars */
import { TextField } from '@mui/material';
import { SelectProps } from '@mui/material/Select';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { VIEW_MODE } from '../../consts/enums';
import { DateValidationFields } from '../../@types/Account';
import style from './style';

type CustomDatePickerProps = SelectProps & {
  viewMode?: ViewMode,
  inputFormat: string,
  minDate?: Date,
  onChange: (value: null | Date) => void,
  onAccept: (value: null | Date) => void,
  valueWithValidation: DateValidationFields,
  label: string,
};

const formats = {
  monthAndYear: 'dd.MM.yyyy',
};

const mask = '__.__.____';

const CustomDatePicker = ({
  viewMode,
  inputFormat,
  minDate,
  onChange,
  valueWithValidation,
  label,
  onAccept,
  // eslint-disable-next-line comma-dangle
  // eslint-disable-next-line react/jsx-props-no-spreading
  ...muiProps
}: CustomDatePickerProps): JSX.Element | null => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const combinedProps = {
    ...(isReadOnly) && {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      IconComponent: () => null,
      sx: { ...muiProps.sx, ...style.disabledInput },
    },
  };

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    <LocalizationProvider dateFormats={ formats } dateAdapter={ AdapterDateFns }>
      <DatePicker
        label={ label }
        inputFormat={ formats.monthAndYear }
        value={ valueWithValidation.value }
        mask={ mask }
        minDate={ minDate }
        onChange={ onChange }
        onAccept={ onAccept }
        // eslint-disable-next-line react/jsx-props-no-spreading
        { ...combinedProps }
        renderInput={ (params) =>  {
          return (
            <TextField
              variant={ isReadOnly ? 'standard' : 'outlined' }
              sx={ isReadOnly ? style.disabledInput : style.defaultStyle }
              // eslint-disable-next-line react/jsx-props-no-spreading
              { ...params }
              error={ valueWithValidation.error }
              helperText={ valueWithValidation.helperText }
            />
          );
        } }
      />
    </LocalizationProvider>
  );
};

CustomDatePicker.defaultProps = {
  viewMode: VIEW_MODE.READ_ONLY,
  minDate: undefined,
};

export default CustomDatePicker;
